export default __webpack_public_path__ + "static/media/icon-bluecheck.a17db709.svg";